import {data} from './state';

/**
 * Establecer un valor para la variable data.
 */
export function resetData(state) {
    state.data = data();
}

/**
 * Establecer un valor para la variable preloader.
 */
export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para la variable sales_budget.
 */
export function setSalesBudget(state, sales_budget) {
    state.sales_budget = sales_budget;
}

/**
 * Establecer un valor para el atributo show de la variable modal.
 */
export function setShowToModal(state, show) {
    state.modal.show = show;
}



// WEBPACK FOOTER //
// ./src/modules/sales_budget_by_contacts_warehouses/mutations.js